import script from "./home_page.vue?vue&type=script&setup=true&lang=js"
export * from "./home_page.vue?vue&type=script&setup=true&lang=js"

import "./home_page.vue?vue&type=style&index=0&id=0f0df1ca&lang=css"

const __exports__ = script;

export default __exports__